import React, { useRef, useState, useEffect } from 'react'
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';
import "../styleCV/CV01.css"
import { Link } from 'react-router-dom';

const CV01 = () => {

    document.body.style.background = "white";

    const [Image, setImage] = useState()
    const [fname, setfname] = useState()
    const [lname, setlname] = useState()
    const [jobTitle, setjobTitle] = useState()
    const [phone, setphone] = useState()
    const [email, setemail] = useState()

    //address info
    const [street, setstreet] = useState()
    const [city, setcity] = useState()
    const [state, setstate] = useState()
    const [country, setcountry] = useState()
    const [postcode, setpostcode] = useState()

    //educational details 
    const [educationHTML, seteducationHTML] = useState()

    //summary
    const [CVDescription, setCVDescription] = useState()

    //skills 
    const [CVSkills, setCVSkills] = useState()

    //Experience
    const [experienceHTML, setexperienceHTML] = useState()

    //Project info
    // const [projectInfoHTML, setprojectInfoHTML] = useState()
    
    //achievements 
    const [CVAchievements, setCVAchievements] = useState()
    
    //languages
    const [langs, setLangs] = useState()

    useEffect(() => {
        //image photo 
        setImage(localStorage.getItem("profilePhoto"));

        //fetch objs from storage 
        const personalInfo = JSON.parse(localStorage.getItem("personalDetails"))
        //personal info
        if (personalInfo !== null) {
            setfname(personalInfo.firstname)
            setlname(personalInfo.lastname)
            setjobTitle(personalInfo.jobtitle)

            //contact info
            setphone(personalInfo.phone)
            setemail(personalInfo.email)

            //address info
            setstreet(personalInfo.address)
            setcity(personalInfo.city)
            setstate(personalInfo.state)
            setcountry(personalInfo.country)
            setpostcode(personalInfo.postcode)
        }

        //educational info
        const education = JSON.parse(localStorage.getItem("Education"));
        populateEducation(education)

        //summary
        setCVDescription(localStorage.getItem("CVDescription"));
        
        //languages
        setLangs(localStorage.getItem("cvlangs"));

        //Experience
        const experience = JSON.parse(localStorage.getItem("ProfessionalExperience"))
        populateExperience(experience);

        //skills
        const skills = JSON.parse(localStorage.getItem('skills'));
        populateSkills(skills)

        //achievements
        const achievements = JSON.parse(localStorage.getItem('achievements'));
        populateAchievements(achievements)
        
        //project Info
        // const projectInfo = JSON.parse(localStorage.getItem('projectInfo'));
        // populateProject(projectInfo);
    }, [])
    

    const populateAchievements = (achievements) => {
        if (achievements[0].achievements !== "") {
            setCVAchievements(
                <>
                    <div className="boxp01" id="Achievementsp01">
                        <h3 className="titlep01" id="Achievementstitlep01">Achievements</h3>
                        <ul className='achievementlistp01'>

                            {achievements.map((ach, index) => (

                                <li className="listitemp01">{ach.achievements}</li>

                            ))}
                        </ul>
                    </div>
                </>
            )
        }
    }

    const populateSkills = (skills) => {
        if (skills[0].skill !== "") {
            setCVSkills(
                <>
                    <div className="boxp01" id="Skillsp01">
                        <h3 className="titlep01" id="Skillstitlep01">Skills</h3>
                        <ul className='skilllistp01'>

                            {skills.map((sk, index) => (

                                <li className="listitemp01">{sk.skill}</li>

                            ))}
                        </ul>
                    </div>
                </>
            )
        }
    }

    const populateExperience = (experience) => {
        if (experience[0].WorkSummary !== "" || experience[0].StartDate !== "" || experience[0].PositionTitle !== "" || experience[0].EndDate !== "" || experience[0].ComponyName !== "") {
            setexperienceHTML(
                <>
                    <h3 className="titlep01" id="expertitlep01">Experience</h3>
                    {experience.map((exp, index) => (
                        <div key={index} className="experienceblock">
                            <div>
                                <div className="jobtitlep01">
                                    <label>{exp.PositionTitle}</label>
                                </div>
                                <div className='companynamep01'>
                                    <span>{exp.CompanyName}</span>
                                </div>
                                <div className="durationp01">
                                    <span className="startdatep01">{exp.StartDate}</span><span>-</span><span className="lastdatep01">{exp.EndDate}</span>
                                </div>
                                <div className="descriptionp01">{exp.WorkSummary}</div>
                            </div>
                        </div>
                    ))}
                </>
            )
        }
    }

    const populateEducation = (education) => {
        if (education[0].schname !== "" || education[0].schloc !== "" || education[0].field !== "" || education[0].edustrdate !== "" || education[0].eduendate !== "" || education[0].deg !== "") {
            seteducationHTML(
                <>
                    <h3 className="titlep01" id="educationtitlep01" >Education</h3>
                    <ul class="leftsidelist1p01">
                        {education.map((edu, index) => (
                            <li>
                                <div>
                                    <h4><span>{edu.deg}</span> in <span>{edu.field}</span></h4>
                                </div>
                                <div><span>{edu.edustrdate}</span> - <span>{edu.eduendate}</span></div>
                                <div>{edu.schname}</div>
                                <div>{edu.schloc}</div>
                            </li>

                        ))}
                    </ul>
                </>
            )
        }
    }

    // const populateProject = (projectInfo) => {
    //     if (projectInfo[0].projectTitle !== "" || projectInfo[0].projectDesc !== "") {
    //         setprojectInfoHTML(
    //             <>
    //                 <div className="boxp01" id="projectp01">
    //                     <h3 className="titlep01" id="protitp01" >Project</h3>
    //                     <div className="projectsListp01">
    //                         {projectInfo.map((prj, index) => (
    //                             <div className="Pro1p01">
    //                                 <div className="protitlep01">{prj.projectTitle}</div>
    //                                 <div className="prodescripp01">{prj.projectDesc}</div>
    //                             </div>
    //                         ))}
    //                     </div>
    //                 </div>
    //             </>
    //         )
    //     }
    // }

    const table = document.getElementById('CVp01');

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });



    const downloadImage = () => {
        html2canvas(table).then(function (canvas) {
            const link = document.createElement('a');
            link.download = 'business.png';
            link.href = canvas.toDataURL('image/png');
            link.click();
        });
    }


    return (<>
        <div className="containerp01">

            <div className="CVp01" ref={componentRef} id="CVp01">

                <div className='upperpartp01'>
                    <div className='imgcontainerp01'>
                        <img className='userPhotop01' src={Image} alt="" />
                    </div>

                    <div className='fullnameAndPostp01'>

                        <div className='namep01'>
                            <span className='fullNamep01'><span>{fname}</span>&nbsp;<span>{lname}</span></span>
                        </div>

                        <div className='positionp01'>
                            <span className='posp01'>{jobTitle}</span>
                        </div>
                    </div>

                    <div className='boxp01' id="contactinfop01" >
                        <h3 className="titlep01" id='conttitle'>Contact</h3>

                        <ul classname="leftsidelistp01">
                            <li>
                                <span className="iconp01" id="icon1p01"><i class="fa fa-phone" aria-hidden="true"></i></span>
                                <span className="text1p01">{phone}</span>
                            </li>
                            <li className='list2p01'>
                                <span className="iconp01" id="icon2p01"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                                <span className="text2p01">{email}</span>
                            </li>
                            {/* <li className='list3itemp01'>
                <span className="iconp01" id="icon3p01"><i class="fa fa-linkedin-square" aria-hidden="true"></i></span>
                <span className="text3p01">www.linked.com </span>
              </li> */}
                            <li className='list4p01'>
                                <span className="iconp01" id="icon4p01"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                                <div className='addresp01'>
                                    <span className="text4p01" ><span>{street}</span>, <span>{city}</span><span>, </span><span>{state}</span>, <span>{country}</span>&nbsp;(<span>{postcode}</span>)</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="lowerpartp01">

                    <div className="leftsidep01">
                        <div className='boxp01' id="Educationp01">
                            {/* <h3 className="titlep01" id="educationtitlep01" >Education</h3> */}
                            {/* <ul class="leftsidelist1p01">
                                <li>
                                    <div>
                                        <h4>Masters degree in computer science</h4>
                                    </div>
                                    <div>2011-2013</div>
                                    <div>d.y.patil university</div>
                                    <div>123 Anywhere st, Any city</div>
                                </li>
                                 
                            </ul> */}
                            {educationHTML}
                        </div>

                        {/* <div className="boxp01" id="Skillsp01">
                            <h3 className="titlep01" id="Skillstitlep01">Skills</h3>
                            <ul className='skilllistp01'>
                                <li className="listitemp01">problem solving</li>
                            </ul>
                        </div> */}
                        {CVSkills}
                        
                        {CVAchievements}
                        
                        <div className="boxp01" id="langboxp01" >
                            <h3 className="titlep01" id="langtitlep01">Languages</h3>
                            <div id="langp01" >{langs}</div>
                        </div>  


                    </div>

                    <div className="rightsidep01">
                        <div className="boxp01" id="summaryboxp01" >
                            <h3 className="titlep01" id="summarytitlep01">Summary</h3>
                            <div id="summaryp01" >{CVDescription}</div>
                        </div>

                        <div className="boxp01" id="experiencep01" >
                            {/* <h3 className="titlep01" id="expertitlep01">Experience</h3> */}
                            {/* <div className="experienceblock">
                                <div className="jobtitlep01">
                                    <label>Full stack developer</label>
                                </div>
                                <div className='companynamep01'>
                                    <span>infosys | </span><span>123,pune shivaji road</span>
                                </div>
                                <div className="durationp01">
                                    <span className="startdatep01">2021</span><span>-</span><span className="lastdatep01">present</span>
                                </div>
                                <div className="descriptionp01">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil cumque fugit praesentium quisquam neque adipisci quidem placeat similique molestias? Velit.</div>
                            </div> */}
                            {experienceHTML}
                        </div>

                        {/* project info */}
                        {/* {projectInfoHTML} */}

                        {/* <div className="boxp01" id="projectp01"> */}
                        {/* <h3 className="titlep01" id="protitp01" >Project</h3> */}
                        {/* <div className="projectsListp01">
                                <div className="Pro1p01">
                                    <div className="protitlep01">data structure library</div>
                                    <div className="prodescripp01">Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, vero?</div>
                                </div>

                                <div className="pro2p01">
                                    <div className='protitlep01'>chatbot</div>
                                    <div className="prodescripp01">Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur repellendus incidunt fuga impedit veniam.</div>
                                </div>
                            </div> */}
                        {/* </div> */}
                    </div>
                </div>
            </div>
            {/* buttons to print the document */}
            <div className="container" style={{ "width": "100%", "display": "flex", "flexDirection": "row", "alignItems": "center", "justifyContent": "center", marginTop: "40px", "gap": "30px" }}>


                <Link to="/CVform1" k><button id='eidtForm' type="button" className="btn btn-success business01-btn">EDIT FORM</button></Link>
                <button id='mybtn' onClick={handlePrint} type="button" className="btn btn-success business01-btn">Download PDF</button>
                <button onClick={downloadImage} type="button" className="btn btn-success business01-btn">Download Image</button>

            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    fontFamily: "kanit",
                    marginBottom: "20px",
                    marginTop: "30px"

                }}
            >
                <Link
                    to="/"
                    class="btn btn-outline-danger"
                    style={{ marginRight: "50px", width: "180px", fontSize: "18px" }}
                >
                    Back
                </Link>

                <Link to="/cv02"

                    class="btn btn-outline-success"
                    style={{ width: "180px", fontSize: "18px" }}
                >
                    Next
                </Link>

{/* <Link to="/" className="btn btn-outline-success"  >&nbsp;&nbsp;&nbsp;&nbsp;Edit form . .&nbsp;&nbsp;&nbsp;&nbsp;</Link>

<button id="mybtn" onClick={handlePrint} type="button" className="btn btn-outline-success mr-2">
  Download PDF
</button>
<button onClick={downloadImage} type="button" className="btn btn-outline-success" >
  Download Image
</button>

<Link to="/" className="btn btn-outline-success"  >&nbsp;&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;&nbsp;</Link> */}

            </div>

        </div >

    </>
    )
}

export default CV01